import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./app/App.tsx";
import "./index.css";
import { isDevelopment } from "./utils";
import { clearLegacyAuthCookies } from "./utils/tokenStorage";

// One-shot cleanup: remove legacy auth cookies from the previous cookie-based
// storage so upgrading users don't retain stale tokens in their cookie jar.
clearLegacyAuthCookies();

// to use Cypress.env in e2e environment
declare global {
  // eslint-disable-next-line @typescript-eslint/consistent-type-definitions
  interface Window {
    Cypress?: { env: (key: string) => string };
  }
}

const shouldStartMocker = import.meta.env.VITE_ENABLE_MSW === "true";

async function setupApp() {
  if (shouldStartMocker && isDevelopment) {
    const mocker = await import("./mocker/index.ts");

    await mocker.runServer();
  }

  return Promise.resolve();
}

const root = createRoot(document.getElementById("root")!);

setupApp()
  .then(() => {
    root.render(
      <StrictMode>
        <App />
      </StrictMode>
    );
  })
  .catch((error: unknown) => {
    console.error("[app] Failed to initialize application", { error });
  });
